import { useTranslation } from 'react-i18next'
import styles from './ProfileInfo.module.scss'

const ProfileInfo = ({ user, currentDynamicUser }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.profile_right_info}>
      <div className={styles.info}>
        <div className={styles.avatar2}>
          <img
            src={currentDynamicUser?.imeag}
            alt=""
            className={styles.image__cover}
          />
        </div>
      </div>
      <div className={styles.info}>
        <p
          style={{
            fontSize: '16px',
            width: '150px',
            borderBottom: '1px solid grey',
          }}
        >
          {currentDynamicUser?.first_name} {currentDynamicUser?.surname}
        </p>
      </div>
      <div className={styles.info}>
        <span>{t('profile.contact_email')}</span>
        {currentDynamicUser?.email === null ? (
          <p style={{ fontSize: '14px' }}>{t('profile.not_specified')}</p>
        ) : (
          <a href="mailto:{user.email}"> {currentDynamicUser?.email} </a>
        )}
      </div>
      <div className={styles.info4}>
        <span>{t('profile.number')}</span>
        <p>
          {currentDynamicUser?.number_phone === null ||
          currentDynamicUser?.number_phone === ''
            ? t('profile.not_specified')
            : currentDynamicUser?.number_phone}
        </p>
      </div>
      <div className={styles.info}>
        {user.user_type === 'S' ? <span>{t('profile.group')}</span> : <span>{t('profile.position')}</span>}
        <p style={{ fontSize: '14px' }}>
          {currentDynamicUser?.position === null ||
          currentDynamicUser?.position === ''
            ? t('profile.not_specified')
            : currentDynamicUser?.position}
        </p>
      </div>
      <div className={styles.info4}>
        {user.user_type === 'S' ? <span>{t('profile.direction')}</span> : <span>{t('profile.subdivision')}</span>}
        <p>
          {currentDynamicUser?.division === null ||
          currentDynamicUser?.division === ''
            ? t('profile.not_specified')
            : currentDynamicUser?.division}
        </p>
      </div>
    </div>
  )
}

export default ProfileInfo
